import PropsTypes from "prop-types";

const OperatorExportReport = {
  type: {
    isOpenModal: PropsTypes.bool.isRequired,
    setIsOpenModal: PropsTypes.func.isRequired,
  },
};

export default OperatorExportReport;
